export class CategoryService {
  public static $inject: Array<string> = ["$http"];
  constructor(private $http: ng.IHttpService) {
  }
  public query(type: string): ng.IPromise<any> {
    return this.$http.get(`${BASE}/classification?type=${type}`).then((data) => {
      return data.data;
    })
  }
}
